export default __webpack_public_path__ + "static/media/remitancewhite.5f79bf95.svg";